module.exports = __webpack_public_path__ + "img/Platform_Gradients-9.6d114582.jpg";